import { useEffect, useRef } from 'react';

import { useParams } from 'react-router-dom';

import { parseApiError } from '@cast/api-client';
import { organizationQueryKey } from '@cast/constants';

import {
  useOrganizations,
  useNavigate,
} from '@cast/infrastructure-organization';
import { SuspenseLoader } from 'components/loaders';
import { apiClient } from '@cast/infrastructure-api';
import { useJoinOrganizationMutation } from 'hooks/mutations/organization';
import { determineCurrentOrganization } from '@cast/shared-organization-context-data-access';

export const InvitationPage = () => {
  const { invitationId } = useParams();
  const { mutate: mutateJoinOrganization } = useJoinOrganizationMutation();
  const navigate = useNavigate();
  const organizations = useOrganizations();

  const handledInvitation = useRef(false);
  useEffect(() => {
    if (invitationId && organizations?.length && !handledInvitation.current) {
      handledInvitation.current = true;
      mutateJoinOrganization(invitationId, {
        onSuccess: async ({ data }) => {
          const { data: organizationsData } =
            await apiClient.user.listOrganizations();
          const joinedOrg = organizationsData.organizations.find(
            (org) => org.id === data.organizationId
          );
          if (
            joinedOrg?.type === 'ORGANIZATION_TYPE_ENTERPRISE' &&
            joinedOrg.id
          ) {
            const childOrg = organizationsData.organizations.find(
              (o) => o.parentId === joinedOrg.id
            );
            if (childOrg) {
              navigate(
                `/dashboard?${organizationQueryKey}=${childOrg.id}&invitationId=${invitationId}`,
                { replace: true }
              );
              return;
            }
          }
          navigate(
            `/dashboard?${organizationQueryKey}=${data.organizationId}&invitationId=${invitationId}`,
            { replace: true }
          );
        },
        onError: (error: unknown) => {
          const errorMessage = parseApiError(error);
          const org = determineCurrentOrganization(organizations);
          navigate(
            `/dashboard?${organizationQueryKey}=${org?.id}&invitationError=${errorMessage}`,
            {
              replace: true,
            }
          );
        },
      });
    }
  }, [invitationId, mutateJoinOrganization, navigate, organizations]);

  return <SuspenseLoader />;
};
